// Package Imports
import { z } from 'zod'

export const periodSearchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
  // Durum filtresi (Hepsi/Aktif/Pasif). Yoksa hepsi.
  status: z.enum(['ALL', 'ACTIVE', 'PASSIVE']).optional(),
})

export const periodFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Periyot adı girilmesi zorunludur')
    .max(120, 'Periyot adı en fazla 120 karakter olmalıdır'),
  interval_value: z
    .number({ message: 'Tekrar aralığı değeri zorunludur' })
    .int('Tekrar aralığı tam sayı olmalıdır')
    .min(1, 'Tekrar aralığı en az 1 olmalıdır')
    .max(1000, 'Tekrar aralığı en fazla 1000 olabilir'),
  interval_unit: z.enum(['MINUTE', 'HOUR', 'DAY', 'WEEK', 'MONTH'], {
    message: 'Tekrar aralığı birimi seçilmesi zorunludur',
  }),
  is_active: z.boolean(),
})

export type TPeriodFormSchema = z.infer<typeof periodFormSchema>
